import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DashboardBizzDevService } from "../../../../shared/services/dashboard-bizz-dev.service";

@Component({
    selector: "app-sic",
    templateUrl: "./sic.component.html",
    styleUrls: ["./sic.component.scss"],
})
export class SicComponent implements OnInit {
    displayedColumns = [
        "provider",
        "amount",
        "totalCount",
        "matchingCount",
        "noMatchingCount",
        "durationTotal",
    ];
    dataSource;
    @ViewChild(MatSort)
    sort: MatSort;
    constructor(private dashboardService: DashboardBizzDevService) {}

    ngOnInit(): void {
        this.getTestStats();
    }

    getTestStats(): void {
        this.dashboardService.getTestStats().subscribe((value) => {
            this.dataSource = new MatTableDataSource(value);
            if (this.sort) {
                this.dataSource.sort = this.sort;
            }
        });
    }
}
